import format from 'date-fns/format'
import { createSelector } from 'reselect'

const getEpochtimes = (state, epochtimes) => {
  return epochtimes
}

export const makeGetMarks = () => {
  return createSelector([getEpochtimes], epochtimes => {
    try {
      const marksLength = epochtimes.length
      const marks = epochtimes.reduce((array, item, index) => {
        array[item] = {
          label: (index === 0 || index === marksLength - 1) ? format(item, 'MMMYYYY') : null,
          value: item
        }
        return array
      }, {})

      return marks
    } catch (error) {
      return {}
    }
  })
}



// WEBPACK FOOTER //
// ./src/selectors/marksSelector.js